export default __webpack_public_path__ + "blue-motherboard.jpg";